// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/it";
import packageJson from "../package.json";

// Detects the browser's language
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // Extracts the language code (e.g., "fr-FR" -> "fr")
  const langCode = browserLang.split('-')[0];
  // Only supports 'en' and 'fr' for now
  return ['en', 'fr', 'de', 'es', 'it'].includes(langCode) ? langCode : 'en';
};

// Synchronize moment.js locale with i18n language
const syncMomentLocale = (language) => {
  moment.locale(language);
};

i18n
  .use(HttpBackend) // Utilisation du backend HTTP pour charger les fichiers de traduction
  .use(initReactI18next) // Liaison avec React
  .init({
    backend: {
      // Version in the URL: the server sends no Cache-Control header, so browsers
      // (and the Android WebView) kept serving the previous translations after a deploy.
      loadPath: `/locales/{{lng}}/translation.json?v=${packageJson.version}`
    },
    fallbackLng: "en",
    parseMissingKeyHandler: (key) => `MISSING TRANSLATION: ${key}`,
    returnEmptyString: false,
    // Ne pas définir lng ici - laisser le SettingsContext gérer la langue pour les utilisateurs connectés
    // Pour les pages publiques (signup, signin), la langue du navigateur sera utilisée via fallbackLng
    interpolation: {
      escapeValue: false // React gère déjà l'échappement
    }
  });

// Synchronise moment.js lors du changement de langue
i18n.on("languageChanged", syncMomentLocale);

// Synchronise moment.js avec la langue initiale si déjà définie
if (i18n.language) {
  syncMomentLocale(i18n.language);
}

export default i18n;